import { createFileRoute } from "@tanstack/react-router";
import AdminCronJobs from "@/pages/admin/AdminCronJobs";

export const Route = createFileRoute("/_adminLayout/admin/cron-jobs")({
  component: AdminCronJobs,
});
